<i18n>
{
  "en": {
    "fields": {
      "headings": {
        "conditional": "Conditional logic"
      },
      "options": {
        "removeOption": "Remove option"
      },
      "conditions": {
        "addCondition": "Add condition",
        "removeCondition": "Remove condition"
      }
    }
  }
}
</i18n>

<template>
  <div class="extension__form">
    <div
      v-for="field in fields"
      :key="field.name"
    >
      <field
        :field="field"
        v-model="object[field.name]"
      ></field>
    </div>

    <!-- Options -->
    <!-- Select -->
    <div
      v-if="object.type === 'select'"
      class="options"
    >
      <h4>{{ $t('fields.headings.options') }}</h4>
      <div
        v-for="(option, index) in object.options"
        :key="`option-${index}`"
        class="row"
      >
        <div class="col">
          <Field v-model="option.key"></Field>
        </div>
        <div class="col">
          <Field v-model="option.label"></Field>
        </div>
        <div class="col">
          <button
            @click="removeOption(index)"
            class="btn"
          >
            {{ $t('fields.options.removeOption') }}
          </button>
        </div>
      </div>
      <button
        @click="addOption"
        class="btn btn--save"
      >
        {{ $t('fields.options.addOption') }}
      </button>
    </div>

    <!-- Reference -->
    <div
      v-if="object.type === 'ref'"
      class="options"
    >
      <h4>{{ $t('fields.headings.relation') }}</h4>
      <Field
        :field="{type: 'select', options: relatable}"
        v-model="object['options']"
      ></Field>
      <h4>Label prop</h4>
      <Field
        :field="{type: 'select', options: modelProps}"
        v-model="object['labelProp']"
      ></Field>
    </div>

    <!-- Multiple? -->
    <div
      v-if="(object.type === 'ref' || object.type === 'select') && object.settings"
      class="settings"
    >
      <h4>{{ $t('fields.headings.multiple') }}</h4>
      <Field
        :field="{ type: 'checkbox' }"
        v-model="object.settings['multiple']"
      />
    </div>

    <!-- Conditional logic -->
    <div class="conditional">
      <h4>{{ $t('fields.headings.conditional') }}</h4>
      <div
        v-for="(condition, index) in object.conditions"
        :key="`condition-${index}`"
        class="row"
      >
        <div class="col">
          <Field
            v-model="condition.relation"
            :field="{ type: 'select', options: relations }"
          ></Field>
        </div>
        <div class="col">
          <Field
            v-model="condition.field"
            :field="{ type: 'select', options: fieldsForOptions }"
          ></Field>
        </div>
        <div class="col">
          <Field
            v-model="condition.comparison"
            :field="{ type: 'select', options: comparisons }"
          ></Field>
        </div>
        <div class="col">
          <Field
            :field="getConditionValueField(index)"
            v-model="condition.value"
          ></Field>
        </div>
        <div class="col">
          <button
            @click="removeCondition(index)"
            class="btn"
          >
            {{ $t('fields.conditions.removeCondition') }}
          </button>
        </div>
      </div>
      <button
        @click="addCondition"
        class="btn btn--save"
      >
        {{ $t('fields.conditions.addCondition') }}
      </button>
    </div>
  </div>
</template>

<script>
import Field from '@/components/Field';

export default {
  props: ['object', 'fieldsForOptions', 'fields', 'types', 'fieldsByType'],
  components: {
    Field,
  },
  computed: {
    relatable() {
      const types = this.typesRenamedForSelect;
      types.push({
        key: 'user',
        label: 'User',
      });
      return types;
    },
    typesRenamedForSelect() {
      return this.renameForSelect(this.types);
    },
    modelProps() {
      const props = [];
      // @todo: make dynamic
      this.$store.getters['fields/getTypeFields']('subject').forEach(item =>
        props.push({
          key: item.key,
          label: item.label,
        }),
      );
      this.$store.getters['fields/getTypeFields']('domain').forEach(item =>
        props.push({
          key: item.key,
          label: item.label,
        }),
      );
      return props;
    },
  },
  data() {
    return {
      relations: [
        {
          key: '&&',
          label: 'AND',
        },
        {
          key: '||',
          label: 'OR',
        },
      ],
      comparisons: [
        {
          key: '==',
          label: 'IS',
        },
        {
          key: '!=',
          label: 'IS NOT',
        },
      ],
    };
  },
  methods: {
    renameForSelect(input) {
      if (typeof input === 'undefined') {
        return [];
      }

      const output = [];

      input.forEach(option => {
        output.push({
          key: option.slug,
          label: option.name,
        });
      });

      return output;
    },
    getConditionValueField(index) {
      if (!this.object.conditions) {
        return {};
      }
      if (!this.object.conditions[index]) {
        return {};
      }
      const found = this.fieldsByType.find(element => {
        return element.key === this.object.conditions[index].field;
      });
      if (!found) {
        return {};
      }
      found.showLabel = false;
      return found;
    },
    addCondition() {
      if (!this.object.conditions) {
        this.object.conditions = [];
      }
      this.object.conditions.push({
        field: '',
        comparison: '==',
        value: '',
        relation: '&&',
      });
      this.object = JSON.parse(JSON.stringify(this.object));
    },
    removeCondition(index) {
      this.object.conditions.splice(index, 1);
    },
    addOption() {
      if (!this.object.options) {
        this.object.options = [];
      }
      this.object.options.push({
        key: '',
        label: '',
      });
      this.object = JSON.parse(JSON.stringify(this.object));
    },
    removeOption(index) {
      this.object.options.splice(index, 1);
    },
  },
};
</script>
